import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import HistoryList from './HistoryList.js';
import { actions } from './HistoryList.actions';
import {
    mainSelector,
    getListPostbacks,
    getHeaderName
} from './HistoryList.selectors';
import {
    getHistoryStatuses,
    getConversionStatuses,
    getActionTypes,
    getActionNames
} from '../../../../selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderName,
    list: mainSelector,
    postbacks: getListPostbacks,
    statuses: getHistoryStatuses,
    conversionStatuses: getConversionStatuses,
    actionTypes: getActionTypes,
    actionNames: getActionNames
});

const HistoryListComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            page: state.postbackHistory.page,
            total: state.postbackHistory.total,
            loading: state.postbackHistory.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getListHistoryPostbacks: actions.getListHistoryPostbacks,
            getListPostbacks: actions.getListPostbacks,
            onResendPostback: actions.onResendPostback.bind(actions)
        };
    }
)(HistoryList);

export default HistoryListComponent;
